import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { apexMove, marketingCandidate, signedOut } from './boot';
import PublicRoot, { loadSite } from './PublicRoot';
import { hostKind, hostUrl, safeReplace } from './services/hosts';
import reportWebVitals from './reportWebVitals';
// Global styles stay in the entry so the marketing page looks exactly as it did
// when it rendered inside the app bundle.
import './App.scss';

// The whole app is its own chunk (D25): a signed-out visitor on the marketing
// page never downloads it. See boot.js.
const App = lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
const render = (node) => root.render(<React.StrictMode>{node}</React.StrictMode>);
const renderApp = () => render(<Suspense fallback={null}><App /></Suspense>);

const kind = hostKind();
const move = apexMove(window.location, kind);
if (move) {
  safeReplace(hostUrl(...move));
} else if (marketingCandidate(window.location, kind)) {
  loadSite();   // in parallel with the sign-in check
  signedOut().then((out) => (out ? render(<PublicRoot />) : renderApp()));
} else {
  renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
